module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/status/statusview/statusview.component.css
// module id = ./src/app/applicant/status/statusview/statusview.component.css
// module chunks = main